export default __webpack_public_path__ + "static/media/03_DAIF_Eco_04_LLAMA.babfafac.mp4";